import axios from "axios";
import { ElNotification } from "element-plus";
import { debounce } from 'lodash-es';

import { ApiPromise } from '@/types/common';

const prefix = process.env.PREFIX_URL || "";
const SUCCESSCODE = 0;
const isWx = (window as any).location.href.includes('source=QYWX'); // code是微信重定向的
const isQy = (window as any).location.href.includes('source=QIYU');
const appendUrl = window.location.search.substring(1);

axios.defaults.withCredentials = true;

const errorHandle = debounce((msg) => {
  ElNotification({
    message: msg,
    type: "error",
  });
}, 300);

const loadToken = executeToken();

axios.interceptors.request.use((config: any) => {
  config.headers['Admin-Token'] = loadToken();
  config.headers['company'] = 'zcj';

  return config;
});

axios.interceptors.request.use((config: any) => {
  if (isWx) {
    config.url = appendSearchParams(config.url, 'source=QYWX');
  } else if (isQy) {
    // config.url = appendSearchParams(config.url, 'source=QIYU');
    config.url = appendSearchParams(config.url, appendUrl);
  }
  return config;
})

axios.interceptors.response.use(
  (response) => {
    // 由于接口返回数据格式特殊，需特殊处理
    if (
      response.config?.responseType === "blob" ||
      (response.config.url &&
        response.config.url.includes("dynamic/constant.do"))
    ) {
      response.data = {
        data: response.data,
        code: SUCCESSCODE,
      };
    }

    if (response.status !== 200 || response.data.code !== SUCCESSCODE) {
      const msg = response?.data?.message || response?.data?.msg

      msg && errorHandle(msg);

      return Promise.reject(response.data);
    }

    return response;
  },
  (err) => {
    Promise.reject(err);
  }
);

export const get = (url: string, params: any = {}, clearFn?: any): ApiPromise => {
  if (!params.params) {
    params.params = {};
  }
  params.params.__searchtime = new Date().getTime();

  return new Promise((resolve) => {
    axios
      .get(prefix + url, params)
      .then((result) => {
        let res;
        if (clearFn !== undefined) {
          res = clearFn(result.data);
        } else {
          res = result.data;
        }
        resolve([null, res]);
      })
      .catch((err) => {
        resolve([err, {}]);
      });
  });
};

export const getBlob = (url: string, params: any = {}, clearFn?: any): ApiPromise => {
  // if (!params.headers) {
  //   params.headers = {};
  // }
  params.responseType = "blob";

  return get(url, params, clearFn);
};

export const postWithJson = (url: string, data: any, params = {}): ApiPromise =>
  new Promise((resolve) => {
    axios
      .post(prefix + url, data, params)
      .then((result) => {
        resolve([null, result.data]);
      })
      .catch((err) => {
        resolve([err, {}]);
      });
  });

// 表单格式提交
export const post = (url: string, data: any, params: any = {}): ApiPromise => {
  params.headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  };

  return new Promise((resolve) => {
    axios
      .post(prefix + url, getQueryString(data), params)
      .then((result) => {
        resolve([null, result.data]);
      })
      .catch((err) => {
        resolve([err, {}]);
      });
  });
};

export const postWithFile = (url: string, formData: any, params: any = {}): ApiPromise => {
  params.headers = {
    "Content-Type": "multipart/form-data",
  };

  return new Promise((resolve) => {
    axios
      .post(prefix + url, formData, params)
      .then((result) => {
        resolve([null, result.data]);
      })
      .catch((err) => {
        resolve([err, {}]);
      });
  });
};

function getQueryString(data = {}) {
  return Object.entries(data)
    .map(
      ([key, value]: any) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");
}


function executeToken() {
  let token = '';
  
  return () => {
    if (token) {
      return token;
    }

    try {
      const data = JSON.parse(window.localStorage.getItem('Admin-Token') || '{}');
  
      token = data.data;
    } catch(e) {
      return token;
    }

    return token;
  }
}

function appendSearchParams(url: string, appendUrl: string) {
  if (!url.includes('?')) {
    url += '?';
  } else {
    url += '&';
  }
  return url + appendUrl;
}
